<template>
  <div>
    <div v-if="useAuth">
      <div class="alert alert-secondary border border-secondary mb-0">
        <div class="alert alert-success text-dark mb-3" role="alert">
          <p class="fs-4 fw-bold">Success!</p>
          <p>
            You have completed the <b>{{ course }} {{ title }}</b>
            activity!
          </p>
          <p class="mb-0">
            Download your <strong>"Certificate of Completion"</strong>and upload
            to Canvas.
          </p>
        </div>
        <div ref="capture" class="card card-complete text-dark bg-light mb-3">
          <div class="card-header h2 fw-bold">Certificate of Completion</div>
          <div class="card-body">
            <h5 class="card-title fw-bold fst-italic h4">
              {{ getFullname }}
            </h5>
            <p class="card-text">
              has completed the <b>{{ course }} {{ title }}</b> activity.
            </p>
            <p class="mb-0">This is their proof of completion.</p>
          </div>
          <div class="card-footer">
            <small class="fw-bold">Completion on {{ completionDate }}</small>
          </div>
        </div>
        <button
          type="button"
          class="btn btn-lg btn-primary fw-bold w-100"
          @click="save()"
        >
          Download <em class="bi bi-download ms-3"></em>
        </button>
      </div>
    </div>
    <div v-else class="alert alert-warning">
      Certificate of Completion requires <b>Authentication</b>.
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";

import { mapGetters } from "vuex";

import { meta } from "@/data/config";

export default {
  name: "CertificateOfCompletion",
  data() {
    return {
      course: meta.course,
      title: meta.title
    };
  },
  computed: {
    ...mapGetters(["getFullname", "useAuth"]),
    completionDate() {
      let now = new Date();

      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const day = now.getDate();

      let hours = now.getHours();
      let minutes = now.getMinutes();
      let seconds = now.getSeconds();

      if (hours < 10) {
        hours = `0${hours}`;
      }

      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }

      const date = `${year}-${month}-${day}`;
      const time = `${hours}:${minutes}:${seconds}`;
      const dateTime = `${date} ${time}`;
      return dateTime;
    }
  },
  methods: {
    save: function () {
      new html2canvas(this.$refs.capture, {
        backgroundColor: null,
        scrollX: 0,
        scrollY: -window.scrollY,
        scale: 1,
        allowTaint: true,
        useCORS: true
      }).then(function (canvas) {
        let uri = canvas.toDataURL();
        let filename = "certificate";
        let link = document.createElement("a");
        if (typeof link.download === "string") {
          link.href = uri;
          link.download = filename;
          //Firefox requires the link to be in the body
          document.body.appendChild(link);
          //simulate click
          link.click();
          //remove the link when done
          document.body.removeChild(link);
        } else {
          window.open(uri);
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!-- Avoid using CSS if a Bootstrap class exists -->
<style scoped>
.bi {
  font-size: 25px;
}
</style>
